'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <h1 className="text-9xl font-bold text-sky-500 opacity-20">404</h1>
        </div>
        <h2 className="text-2xl font-semibold text-white mb-2">Pagina non trovata</h2>
        <p className="text-secondary-color mb-8">
          La pagina che stai cercando non esiste o è stata spostata.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => router?.back()}
            className="inline-flex items-center justify-center gap-2 border border-border bg-surface text-white px-6 py-3 rounded-lg font-semibold hover:bg-surface-elevated transition-colors"
          >
            <Icon name="ArrowLeftIcon" size={16} />
            Torna indietro
          </button>
          <button
            onClick={() => router?.push('/network-dashboard')}
            className="inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            <Icon name="HomeIcon" size={16} />
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}